export default {
    en: {
        tab: {
            printReport: 'Print Report',
            printReportTerm: 'Print Report(For reference Only)',
            preJudgement: 'Previous Review',
            achievementReport: 'Faculty Achievement Report',
        },
        list: {
            pReportType: 'Report Type',
            promotion: 'Promotion',
            reappointment: 'Reappointment',
            payGradeIncrease: 'Pay Grade Increase',
            preJudgement:{
                pReportType: 'Classification of Report',
                hyhg: 'Year-semester',
                file: 'Attachments',
                user: 'user',
            },
            achievementReport:{
                pReportType:'Category',
                period:'Period'
            }
        },
        help:{
            printReport:{
                title:'How to print out report',
                line1:'Confirm the evaluation period and type, and click \'Search\' button to create the report. You can select the file type and download the report.',
                line2:'It takes time to create report which refers to several major databases in Yonsei.',
                line3:'Every achievement except TBD/carryover should be registered and approved by several DB such as YRI, YSIS, RMS, etc.. ',
                line3Blue:'After each achievement is transferred to TAMS, you must confirm that all mandatory categories are filled out including journal ranking and the number of authors, and then press \'Save\' button to calculate points. If points of achievements are zero (0), the achievements are not show in the Performance Report.',
                line4:'If you are not going to apply for promotion, click \'CLEAR\' button right side and then click \'Search\' button to print out the report.',
                line5:'The number of authors showing in the report does not include the number of \'Ph.D. candidate and research assistants’.',
                line6:'There are annual maximum allowance scores for Academic activities, Academic-Industrial cooperation activities including research funds, Intellectual property rights, tech transfer and tech consulting, Masters/Ph.D. graduate dissertation advising and on/off-campus services by the related detailed rules.',
                line7:'Therefore, the final score of the report may differ from the sum of each achievement.',
            },
            printReportTerm:{
                line1:'Using this menu for faculty members who are not subject to evaluation in the semester.',
                line2:'Set the evaluation period to see the score.',
            }
        }
    },
    ko: {
        tab: {
            printReport: '보고서',
            printReportTerm: '보고서(점수확인용)',
            preJudgement: '이전심사 제출목록',
			achievementReport: '교원연구업적보고서',
        },
        list: {
            pReportType: '보고서 구분',
            promotion: '승진',
            reappointment: '재임용',
            payGradeIncrease: '승봉',
            preJudgement:{
                pReportType: '보고서 구분',
                hyhg: '학년도 학기',
                file: '제출 파일',
                user: '사용자',
            },
            achievementReport:{
                pReportType:'보고서 구분',
                period:'기간'
            }
        },
        help:{
            printReport:{
                title:'보고서 출력안내',
                line1:'업적보고서 및 평가의견서는 위의 “검색” 버튼을 눌러서 보고서를 생성한 후, 미리보기 화면에서 파일형태를 선택하여 다운로드하십시오.',
                line2:'교내 여러 시스템의 DB를 참조하므로 보고서 생성에 다소 시간이 소요됨을 양지하여 주시기 바랍니다.',
                line3:'연구업적(논문, 저역서, 학술활동, 연구비, 지적재산권 등)은 YRI/YSIS 등에서 입력/승인된 업적이 이 시스템(TAMS)으로 연동되며, ',
                line3Blue: '반드시 이 시스템의 연구업적평가 메뉴에서 각 업적을 클릭하셔서 필수항목(등급, 저자수 등 포함) 입력 후 저장하여야 보고서에서 점수가 출력됩니다(각 업적 점수가 0인 경우에는 보고서 출력시 반영되지 않으니 유의하시기 바랍니다).',
                line4:'승진 및 재임용 심사 대상자가 재임용 심사만 받을 경우 “승진”란의 “미신청” 버튼을 누르고 보고서를 출력하시기 바랍니다(미신청 버튼은 저장되지 않으므로, 페이지 접속시 매번 클릭해야 함).',
                line5:'교원업적 보고서의 저자수에는 공동연구 가중치 산정시 포함되지 않는 ‘박사 후 과정 및 연구조원’ 인원은 포함되지 않습니다.',
                line6:'학술활동 및 산학협력활동(연구비, 특허, 기술이전, 산업자문), 석박사 배출실적, 교내외 봉사활동 등의 업적은 규정상 연간취득상한기준이 적용됩니다(「교원업적평가시행세칙」 제50조, [별표 8], [별표 10~12]).',
                line7:'따라서, 「교원업적 평가의견서/종합 평가의견서」 상의 “제출점수((연구)업적총점) 및 각 업적 합계”는 상기 연간취득 상한이 반영되어 산출된 점수이므로, 「교원업적 보고서」의 업적 건별을 단순 합산한 합계 점수와 일치하지 않습니다.',
            },
            printReportTerm:{
                line1:'금번 학기에 심사대상이 아닌 교수님을 위한 확인용 보고서 출력입니다.',
                line2:'심사 대상기간을 변경하여 총업적점수를 확인하실 수 있습니다.',
            }
        }
    }
}